var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import React, { useContext } from 'react';
import { useTranslation } from 'react-i18next';
import { Redirect } from 'react-router';
import { useUrlProps } from '../../common/urlProps';
import useLoginTheme from '../../common/useLoginTheme';
import AuthService from '../../domain/AuthService';
import { User } from '../../domain/Models';
import gs from '../../styles/style';
import { UserContext } from '../Auth/UserProvider';
import ErrorResponseHandler from '../Common/ErrorResponseHandler';
import { Errors, Form, Input, SubmitButton, useForm } from '../Common/Form';
import style from './Verification.scss';
var FontAwesomeIcon = require('@fortawesome/react-fontawesome').FontAwesomeIcon;
var Verification = function () {
    useLoginTheme();
    var t = useTranslation()[0];
    var _a = useContext(UserContext), user = _a.user, setUser = _a.setUser;
    var urlProps = useUrlProps();
    var form = useForm({
        onSubmit: function (data) {
            data.user = user;
            data.token = urlProps.get('token');
            return AuthService.verifyUser(data);
        },
        onSuccess: function (user) {
            setUser(new User(user));
        }
    });
    if (!user || user.email_verified_at) {
        return React.createElement(Redirect, { to: "/" });
    }
    return React.createElement("div", { className: style['verification-container'] },
        React.createElement(ErrorResponseHandler, null),
        React.createElement("h1", { className: gs('mb-5') }, t('lotus')),
        React.createElement("div", { className: gs('card') },
            React.createElement("div", { className: gs('card-body', style['verification-form']) },
                user && React.createElement(Form, { form: form },
                    React.createElement("h4", { className: gs('mt-2', 'text-center') },
                        React.createElement("span", { className: gs('text-muted') },
                            React.createElement(FontAwesomeIcon, { icon: "lock" })),
                        ' ',
                        t('please_create_password', { name: user.name })),
                    React.createElement("hr", { className: gs('mt-4', 'mb-4') }),
                    React.createElement("fieldset", null,
                        React.createElement("div", { className: gs('form-group') },
                            React.createElement("label", null, t('password')),
                            React.createElement(Input, __assign({}, form.password('password'), { autoFocus: true, className: gs('form-control-lg'), required: true })),
                            React.createElement(Errors, { attribute: "password", errors: form.getErrors('password') })),
                        React.createElement("div", { className: gs('form-group', 'last') },
                            React.createElement("label", null, t('password_repeat')),
                            React.createElement(Input, __assign({}, form.password('password_repeat'), { className: gs('form-control-lg'), required: true })),
                            React.createElement(Errors, { attribute: "password_repeat", errors: form.getErrors('password_repeat') })),
                        React.createElement(SubmitButton, { form: form, className: gs('btn-block', 'btn-lg') }, t('create_password')))),
                !user && t('invalid_token'))));
};
export default Verification;
